import React from 'react';
import {t} from '@lingui/core/macro';

import MainModal from 'shared/ui/Modal/MainModal';
import {ExceededModal} from 'entities/user';
import {useMonitorModalState, MonitorToggle} from 'entities/monitor';
import useCanCreateHttpMonitor from 'features/http/model/useCanCreateHttpMonitor';
import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';

import HttpMonitorForm from './HttpMonitorForm/HttpMonitorForm';
import HttpMonitorBatchCreateForm from './HttpMonitorForm/HttpMonitorBatchCreateForm';

interface IHttpMonitorModalProps {
    open: boolean,
    item?: IHttpMonitorOutput,
    handleClose: () => void;
    onMonitorCreated?: () => void;
}

const HttpMonitorModal: React.FC<IHttpMonitorModalProps> = ({open, item, handleClose, onMonitorCreated}) => {
    const canCreateMonitor = useCanCreateHttpMonitor();

    const isNew = !item;
    const {isBatchMode, showToggle, toggleBatchMode, setShowResult, handleCloseAndReset} = useMonitorModalState(
        isNew,
        handleClose,
    );

    const handleSuccess = () => {
        handleCloseAndReset();

        if (!item && onMonitorCreated) {
            setTimeout(() => {
                onMonitorCreated();
            }, 5000);
        }
    };

    const getHeader = () => {
        if (isBatchMode) {
            return t`Создание сайтов`;
        }
        return isNew ? t`Создание сайта` : t`Редактирование сайта`;
    };

    return <MainModal
        header={getHeader()}
        open={open}
        handleClose={handleCloseAndReset}
        size="md"
    >
        {showToggle && <MonitorToggle isBatchMode={isBatchMode} handleModeToggle={toggleBatchMode}/>}
        {isBatchMode ? (
            canCreateMonitor ? (
                <HttpMonitorBatchCreateForm handleClose={handleSuccess} onShowResultChange={setShowResult}/>
            ) : (
                <ExceededModal
                    isOpen={true}
                    handleClose={handleCloseAndReset}
                />
            )
        ) : (
            <HttpMonitorForm onSuccess={handleSuccess} item={item} onClose={handleCloseAndReset}/>
        )}
    </MainModal>;
};

export default HttpMonitorModal;